import * as React from 'react'

function IconBook(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={70}
      height={61}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3 14.734a90.221 90.221 0 015.975-.963v29.47c13.737-2.34 13.11 9.71 26.025 14.743-12.915-5.034-18.263-6.13-32-3.789V14.734v0z"
        stroke="#FDB800"
        strokeWidth={5}
        strokeMiterlimit={22.926}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M8.973 3.78c13.778-2.642 13.091 9.55 26.025 14.743v39.46C22.083 52.95 22.71 40.902 8.973 43.242V3.781z"
        stroke="#FDB800"
        strokeWidth={5}
        strokeMiterlimit={22.926}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M67 14.734a90.22 90.22 0 00-5.975-.963v29.47c-13.737-2.34-13.11 9.71-26.025 14.743 12.915-5.034 18.263-6.13 32-3.789V14.734v0z"
        stroke="#E84E25"
        strokeWidth={5}
        strokeMiterlimit={22.926}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M61.025 3.78C47.247 1.138 47.934 13.33 35 18.523v39.46c12.915-5.033 12.288-17.082 26.025-14.742V3.781z"
        stroke="#E84E25"
        strokeWidth={5}
        strokeMiterlimit={22.926}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.117 11.459c9.583-.277 10.845 8.375 19.727 13.564M12.117 33.403c9.583-.276 10.845 8.376 19.727 13.565M12.117 22.967c9.583-.276 10.845 8.376 19.727 13.565M57.887 11.459c-9.583-.277-10.845 8.375-19.727 13.564M57.887 33.403c-9.583-.276-10.845 8.376-19.727 13.565M57.887 22.967c-9.583-.276-10.845 8.376-19.727 13.565"
        stroke="#FDB800"
        strokeWidth={5}
        strokeMiterlimit={22.926}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconBook
